/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import ExifReader from 'exifreader';

@Injectable({ providedIn: 'root' })
export class ExifMetadataService {
  constructor(private http: HttpClient) {}

  async readFromBase64(imageData: string): Promise<Record<string, any>> {
    const base64Payload = imageData.includes(',') ? imageData.split(',')[1] : imageData;
    const binaryString = atob(base64Payload);
    const length = binaryString.length;
    const bytes = new Uint8Array(length);

    for (let index = 0; index < length; index++) {
      bytes[index] = binaryString.charCodeAt(index);
    }

    return ExifReader.load(bytes.buffer) as Record<string, any>;
  }

  async readFromUrl(imageUrl: string, options?: { assumeBlobUrl?: boolean }): Promise<Record<string, any>> {
    const blob = options?.assumeBlobUrl || imageUrl.startsWith('blob:')
      ? await this.fetchBlobFromBlobUrl(imageUrl)
      : await firstValueFrom(this.http.get(imageUrl, { responseType: 'blob' }));

    return this.readFromBlob(blob);
  }

  private async fetchBlobFromBlobUrl(blobUrl: string): Promise<Blob> {
    const response = await fetch(blobUrl);
    if (!response.ok) {
      throw new Error(`Failed to fetch blob for EXIF (${response.status})`);
    }

    return response.blob();
  }

  private async readFromBlob(blob: Blob): Promise<Record<string, any>> {
    const arrayBuffer = await blob.arrayBuffer();
    return ExifReader.load(arrayBuffer) as Record<string, any>;
  }
}
